import { create } from 'zustand';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface Store {
  isOpen: boolean;
  message: string;
  type: NotificationType;
  open: (data: { message: string; type?: NotificationType }) => void;
  close: () => void;
}

const useNotificationStore = create<Store>((set) => ({
  isOpen: false,
  message: '',
  type: 'warning',
  open: (data) =>
    set({
      isOpen: true,
      message: data.message,
      type: data.type || 'warning',
    }),
  close: () => set({ isOpen: false }),
}));

export default useNotificationStore;
